export default {
  "title": "Relatórios",
  "subtitle": "Consulte posições, atividade dos dispositivos e alertas da sua conta. Exporte os dados do período para análise.",
  "export": "Exportar CSV",
  "type": "Tipo de relatório",
  "device": "Dispositivo",
  "from": "Data inicial",
  "to": "Data final",
  "generate": "Gerar relatório",
  "today": "Hoje",
  "last_days": "Últimos {days} dias",
  "timezone": "Horários em {timezone}",
  "pending": "Filtros alterados. Gere o relatório para atualizar os resultados e a exportação.",
  "devices_error": "Não foi possível carregar o filtro de dispositivos. Atualize a página para tentar novamente.",
  "loading": "Preparando relatório…",
  "load_error": "Não foi possível carregar o relatório. Tente novamente.",
  "invalid_dates": "Informe um período válido, com a data final igual ou posterior à inicial.",
  "empty": "Nenhum registro neste período",
  "empty_hint": "Tente outro período ou selecione todos os dispositivos.",
  "total": "{total} registros",
  "retention": "Posições e alertas limitados aos últimos {days} dias disponíveis no plano e aos dispositivos que você pode acessar. Contagens consideram o período filtrado; ausência de posições não significa aparelho desligado.",
  "export_hint": "CSV com todas as linhas filtradas, até {limit} registros por exportação. Datas no arquivo em UTC e colunas identificadas por nomes técnicos.",
  "generated_at": "Gerado em {time}",
  "export_pdf": "Exportar PDF",
  "business_only": "Business",
  "check_locked": "O check de segurança é exclusivo do plano Business. Fale com o comercial para ativar.",
  "check": {
    "verdict_title": "Veredito por dispositivo",
    "alerts_title": "Alertas de validação",
    "alerts_empty": "Nenhum alerta de validação no período.",
    "footer_cap": "Listas limitadas aos 500 registros mais recentes por seção. O PDF consolida o mesmo período filtrado.",
    "stats": {
      "devices": "Dispositivos",
      "suspect": "Suspeitos",
      "positions": "Posições",
      "alerts": "Alertas"
    },
    "cols": {
      "device": "Dispositivo",
      "positions": "Posições",
      "travel": "Teletransporte",
      "tamper": "Sabotagem",
      "verdict": "Veredito",
      "when": "Detectada em",
      "kind": "Tipo",
      "detail": "Detalhe"
    },
    "verdict": {
      "clean": "Íntegro",
      "suspect": "Suspeito"
    },
    "kinds": {
      "impossible_travel": "Deslocamento impossível",
      "device_tamper": "Sabotagem",
      "sim_changed": "Troca de SIM"
    }
  },
  "types": {
    "locations": "Posições registradas",
    "devices": "Atividade por dispositivo",
    "alerts": "Alertas",
    "security_check": "Check de segurança"
  },
  "descriptions": {
    "locations": "Local, horário, precisão e bateria de cada observação.",
    "devices": "Quantidade de posições e primeira e última detecção no período.",
    "alerts": "Ocorrências de cercas e dispositivos e sua situação de leitura.",
    "security_check": "Validação de GPS: teletransporte e sabotagem, com veredito por aparelho. Plano Business."
  },
  "stats": {
    "devices": "Dispositivos no filtro",
    "positions": "Posições no período",
    "devices_with_positions": "Com posições no período",
    "alerts": "Alertas no período"
  },
  "columns": {
    "device_name": "Dispositivo",
    "detected_at": "Detectado em",
    "latitude": "Latitude",
    "longitude": "Longitude",
    "accuracy_m": "Precisão",
    "battery_pct": "Bateria",
    "source": "Origem",
    "platform": "Plataforma",
    "positions": "Posições",
    "first_detection": "Primeira detecção",
    "last_detection": "Última detecção",
    "occurred_at": "Ocorrido em",
    "title": "Ocorrência",
    "kind": "Tipo",
    "is_read": "Leitura"
  },
  "kinds": {
    "geofence_transition": "Entrada / saída de cerca",
    "battery_low": "Bateria baixa",
    "low_battery": "Bateria baixa",
    "device_offline": "Sem atualização",
    "sharing_paused": "Compartilhamento pausado"
  },
  "platforms": {
    "mobile": "Rastreador",
    "ble_tag": "Localizador Bluetooth",
    "tag": "Localizador",
    "android": "Android",
    "ios": "iOS"
  },
  "sources": {
    "mobile_app": "Aplicativo rastreador",
    "tagit": "Localizador",
    "simulator": "Simulador"
  }
}
